import * as React from "react";
import {connect} from 'react-redux';
import classNames = require("classnames");
import {Modal, ModalBody, ModalHeader, ModalTitle, ModalFooter} from 'react-bootstrap';
import {DisplayFeature, UserSession, DisplayFeatureType} from "../../domain";
import {
    OnDeleteComments,
    onDeleteComments,
    OnNewFeatureComment,
    onNewFeatureComment,
    onResolveIssue, setCommentsModalVisible, setFeatureOrTypeIdForComments
} from "../../../../actions/actions";
import * as selectors from "../../selectors";
import CommentIcon from "../CommentIcon";
import {SubmitComment} from "../../domain";
import FeatureLock from "../FeatureLock";
import FeaturesState from "../../domain/FeaturesState";
import {ValidationIssue} from "../../../../../integration/representation/validation-issue";
import {Comment} from "../../../../../integration/representation/contract";

interface CellState {
}

interface TagProps {
    feature: DisplayFeature;
    comments: Comment[];
}

interface DispatchProps {
    onDeleteComments: OnDeleteComments;
    onNewComment: OnNewFeatureComment;
    setFeatureOrTypeIdForComments: (feature: string | number) => void;
    showCommentsModal: () => void;
}

interface StateProps {
    user: UserSession;
    selectedFeatureIds: Array<string>;
    contractId: string;
    selectedFeatureType: DisplayFeatureType;
    useDescriptiveName: boolean;
}

type Props = TagProps & StateProps & DispatchProps;

class TitleCell extends React.Component<Props, CellState> {

    render() {
        let {feature, user, selectedFeatureIds,useDescriptiveName, comments} = this.props;
        let cellValueClasses = classNames({
            'title-cell': true,
        });

        const name = useDescriptiveName ? feature.descriptiveName : feature.name;

        return (
            <div className={cellValueClasses}>
                <div className="flex">
                    <div className="alias flex-grow" style={{"marginRight": "20px"}}>
                        {name}
                    </div>

                    <div className="flex" onClick={(e) => e.stopPropagation()}>

                        <IssuesBubble feature={feature}/>
                        <CommentIcon enableCommentCopy={true}
                                     onDeleteComments={this.props.onDeleteComments}
                                     onNewComment={this.handleNewComment.bind(this)}
                                     user={user}
                                     source={feature}
                                     comments={comments}
                                     objectId={feature.id}
                                     objectName={name}
                                     selectedFeatures={selectedFeatureIds}
                                     contractId={this.props.contractId}
                                     showCommentsModal={this.props.showCommentsModal}
                                     setFeatureOrTypeIdForComments={this.props.setFeatureOrTypeIdForComments}/>
                        <FeatureLock feature={feature} />

                    </div>
                </div>
            </div>
        );
    }

    handleNewComment = (comment: string, error: boolean, copyComment: boolean) => {
        let {contractId, feature, selectedFeatureType} = this.props;
        this.props.onNewComment(new SubmitComment(contractId, feature.id, 'FEATURE', selectedFeatureType.destination, this.props.user.username, error, comment, copyComment));
    };


}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        user: selectors.user(state),
        selectedFeatureIds: selectors.selectedFeatureIds(state),
        contractId: selectors.contractId(state),
        selectedFeatureType: selectors.selectedFeatureType(state),
        useDescriptiveName: selectors.stateUseDescriptiveName(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    onDeleteComments: onDeleteComments,
    onNewComment: onNewFeatureComment,
    setFeatureOrTypeIdForComments,
    showCommentsModal: () => setCommentsModalVisible(true)
});

export default connect(mapStateToProps, mapDispatchToProps)(TitleCell);


/// /// IssuesBubble - internal component /// ///
interface BubbleState {
    showIssuesModal: boolean;
}

interface BubbleProps {
    feature: DisplayFeature;
}

class IssuesBubble extends React.Component<BubbleProps, BubbleState> {

    constructor(props: BubbleProps) {
        super(props);
        this.state = {
            showIssuesModal: false
        }
    }

    countIssuesToDisplay(issueArray: ValidationIssue[]) {
        const issuesToDisplay = issueArray.filter(issue => issue.display);
        return issuesToDisplay.length;
    }

    render() {
        let {feature} = this.props;
        let issues = feature.issues;

        const numberOfNotabenesToDisplay = this.countIssuesToDisplay(issues.notabenes);
        const numberOfWarningsToDisplay = this.countIssuesToDisplay(issues.warnings);
        const numberOfErrorsToDisplay = this.countIssuesToDisplay(issues.errors);

        const numberOfIssues = numberOfNotabenesToDisplay + numberOfWarningsToDisplay + numberOfErrorsToDisplay;

        let severity = null;
        severity = numberOfNotabenesToDisplay > 0 ? "notabene" : severity;
        severity = numberOfWarningsToDisplay > 0 ? "warning" : severity;
        severity = numberOfErrorsToDisplay > 0 ? "error" : severity;

        return (
            <div className="issues">
                {numberOfIssues > 0 && (
                    <span className={"bubble " + severity}
                          onClick={() => this.showIssuesModal()}>{numberOfIssues}</span>
                )}
                {this.state.showIssuesModal && (

                    <IssuesModal handleClose={this.closeIssuesModal.bind(this)} feature={feature}/>
                )}

            </div>
        )
    }

    showIssuesModal() {
        this.setState({showIssuesModal: true});
    }

    closeIssuesModal() {
        this.setState({showIssuesModal: false});
    }
}

/// /// IssuesModal -- internal component /// ///
interface ModalState {
}

interface ModalTagProps {
    feature: DisplayFeature;
    handleClose: Function;
}

interface ModalStateProps {
    userCanResolveIssues?: boolean;
    doResolveIssue?: Function;
}

type ModalProps = ModalTagProps & ModalStateProps;

class IssuesModalElement extends React.Component<ModalProps, ModalState> {
    render() {
        let {feature, userCanResolveIssues} = this.props;
        let notabenes = feature.issues.notabenes;
        let warnings = feature.issues.warnings;
        let errors = feature.issues.errors;


        return (
            <Modal show={true} onHide={this.props.handleClose} className="issuesModal">
                <ModalHeader>
                    <ModalTitle>Feil og advarsler</ModalTitle>
                </ModalHeader>
                <ModalBody>

                    {errors.length > 0 && (
                        <div>
                            <h3>Feil</h3>
                            <ul className="issueList">
                                {errors.map(issue => {
                                    return (<li key={issue.id}>{issue.message}</li>)
                                })}
                            </ul>
                        </div>
                    )}

                    {warnings.length > 0 && (
                        <div>
                            <h3>Advarsler</h3>
                            <ul className="issueList">
                                {warnings.map(issue => {
                                    return (
                                        <li key={issue.id}>
                                            <div>
                                                {issue.message}
                                            </div>
                                            {userCanResolveIssues &&
                                            <div className="issueResolveButtons">
                                                <button onClick={() => this.props.doResolveIssue(issue, false)}>Ignorer
                                                </button>
                                                <button onClick={() => this.props.doResolveIssue(issue, true)}>Ignorer
                                                    alle
                                                </button>
                                            </div>
                                            }
                                        </li>)
                                })}
                            </ul>
                        </div>
                    )}

                    {notabenes.length > 0 && (
                        <div>
                            <h3>Notabener</h3>
                            <ul className="issueList">
                                {notabenes
                                    .filter(issue => issue.display)
                                    .map(issue => {
                                        return (
                                            <li key={issue.id}>
                                                <div>
                                                    {issue.message}
                                                </div>
                                                {userCanResolveIssues &&
                                                <div className="issueResolveButtons">
                                                    <button onClick={() => this.props.doResolveIssue(issue, false)}>Ignorer
                                                    </button>
                                                    <button onClick={() => this.props.doResolveIssue(issue, true)}>Ignorer
                                                        alle
                                                    </button>
                                                </div>}
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    )}

                </ModalBody>
                <ModalFooter>
                    <button onClick={() => this.props.handleClose()}>Lukk</button>
                </ModalFooter>
            </Modal>
        );
    }
}


const mapStateToPropsIM = (state: FeaturesState) => {
    return {
        userCanResolveIssues: selectors.userCanResolveIssues(state)
    }
};

const mapDispatchToPropsIm = {
    doResolveIssue: onResolveIssue
};

const IssuesModal = connect(mapStateToPropsIM, mapDispatchToPropsIm)(IssuesModalElement);